import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { useAutoCycleList } from '@composables';
import { Promotion as PromotionData } from '@interfaces';

/** `SectionPromotions` component properties. */
export interface Props {
  promotions: PromotionData[];
}


const INTERVAL_DURATION = 15_000;

const __default__ = { name: 'SectionPromotions' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    promotions: null
  },
  setup(__props: any) {

const props = __props as {
  promotions: PromotionData[];
};



const { state, paused, start, stop, select } = useAutoCycleList(
  props.promotions,
  INTERVAL_DURATION,
);

const animationDuration = (INTERVAL_DURATION * 0.001).toString() + 's';

const videoUrl = computed(() => {
  const videoId = state.value?.youtubeVideoId;

  return videoId && typeof videoId === 'string'
    ? `https://www.youtube.com/embed/${videoId}`
    : null;
});

return { __sfc: true,INTERVAL_DURATION, props, state, paused, start, stop, select, animationDuration, videoUrl }
}

})